import { apiErrorHandler } from '@/helpers/errorHandlers'

import API from '../client'

const fetchClinicHistoriesFragments = async (params) => {
  const route = `api/clinicHistoryFragments`
  return API.get(route, { params })
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const addNewClinicHistoryFragment = async (data) => {
  const route = `api/clinicHistoryFragments`
  return API.post(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const deleteClinicHistoryFragment = async (id) => {
  const route = `api/clinicHistoryFragments/${id}`
  return API.delete(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const putClinicHistoryFragment = async (data) => {
  const route = `api/clinicHistoryFragments`
  return API.put(route, data)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

const fetchSingleClinicHistoryFragment = async (id) => {
  const route = `api/clinicHistoryFragments/${id}`
  return API.get(route)
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(apiErrorHandler(error.response.data)))
}

export {
  addNewClinicHistoryFragment,
  deleteClinicHistoryFragment,
  fetchClinicHistoriesFragments,
  fetchSingleClinicHistoryFragment,
  putClinicHistoryFragment,
}
